import Swiper from 'swiper/js/swiper';

document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.slider-reviews', {
        slidesPerView: 1,
        effect: 'fade',
        fadeEffect: {
            crossFade: true,
        },
        loop: true,
        speed: 500,
        navigation: {
            nextEl: '.reviews__next',
            prevEl: '.reviews__prev',
        },
    });
});
